import React from "react";

function CCTVPrivacy() {
    return (
        <div>
            <h2>Data Protection & Privacy</h2>
            <p>
                CCTV operators must handle personal data responsibly and in compliance with the law. This module explores how to protect individuals’ privacy, follow data protection principles, and avoid misuse of surveillance footage.
            </p>

            <h3>Key Legislation</h3>
            <ul>
                <li><strong>Data Protection Act 2018</strong> – UK implementation of GDPR</li>
                <li><strong>Human Rights Act 1998</strong> – Article 8: Right to privacy</li>
                <li><strong>Freedom of Information Act 2000</strong> – Right to request access to recorded data</li>
            </ul>

            <h3>Data Protection Principles</h3>
            <ul>
                <li>Process data lawfully, fairly, and transparently</li>
                <li>Collect only what is necessary for a specific purpose</li>
                <li>Keep data accurate and up to date</li>
                <li>Store data securely and limit access</li>
                <li>Retain data only as long as necessary</li>
                <li>Allow individuals to access their personal data</li>
            </ul>

            <h3>Respecting Privacy</h3>
            <ul>
                <li>Avoid unnecessary or excessive surveillance</li>
                <li>Do not monitor private areas (e.g. toilets, changing rooms)</li>
                <li>Use signage to inform the public of CCTV use</li>
                <li>Do not share footage without proper authorization</li>
                <li>Blur or redact third parties when sharing footage externally</li>
            </ul>

            <h3>Secure Handling of Footage</h3>
            <ul>
                <li>Restrict access to authorized personnel only</li>
                <li>Use secure systems for storage and transfer</li>
                <li>Log all access to recorded material</li>
                <li>Follow your organization’s data retention policy</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> A member of the public requests access to footage of themselves. What steps must you follow to comply with data protection laws?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://ico.org.uk/for-organisations/guide-to-data-protection/" target="_blank" rel="noreferrer">ICO – Guide to Data Protection</a></li>
                <li><a href="https://www.gov.uk/data-protection" target="_blank" rel="noreferrer">UK Gov – Data Protection Overview</a></li>
                <li><a href="https://www.gov.uk/government/publications/surveillance-camera-code-of-practice" target="_blank" rel="noreferrer">Surveillance Camera Code of Practice</a></li>
            </ul>
        </div>
    );
}

export default CCTVPrivacy;
